import * as React from "react";

const { Component } = React;

import ImportScadsysUsers from "./Scadsys/ScadsysUserSync";
import ImportScadsysPhotos from "./Scadsys/ScadsysPhotoSync";
import ImportScadsysGroups from "./Scadsys/ScadsysGroupSync";
import ExportUsersToScadsys from "./Scadsys/ScadsysUserUpdate";
import ExportAzurePhotos from "./AzurePhotos";

import ExportEntegyUsers from "./Entegy";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImportADAMStudents from "./ADAM/ImportADAMStudents";
import ImportADAMStaff from "./ADAM/ImportADAMStaff";
import ImportADAMClasses from "./ADAM/ImportADAMClasses";

import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";
import * as AccountStore from "../account/AccountStore";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import ImportEdAdminUsers from "./EdAdmin";
import ImportScadsysVisitors from "./Scadsys/ScadsysVisitorSync";
export class Integration {
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;

    constructor(name = "") {
        this.name = name;
    }
}

interface Tabs {
    scadsysImport: boolean;
    scadsysPhotoImport: boolean;
    scadsysGroupImport: boolean;
    scadsysUpdate: boolean;
    excel: boolean;
    entegy: boolean;
    adamStudents: boolean;
    adamStaff: boolean;
    adamClasses: boolean;
    azurePhoto: boolean;
    edadmin: boolean;
    scadsysVisitorImport: boolean;
}

interface IntegrationsState {
    tabs: Tabs;
    policies: any;
    currentUser: any;
}

interface IntegrationsProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class Integrations extends Component<IntegrationsProps, IntegrationsState> {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                scadsysImport: true,
                scadsysPhotoImport: false,
                scadsysGroupImport: false,
                scadsysUpdate: false,
                excel: false,
                entegy: false,
                adamStudents: false,
                adamStaff: false,
                adamClasses: false,
                azurePhoto: false,
                edadmin: false,
                scadsysVisitorImport: false,
            },
            policies: undefined,
            currentUser: undefined,
        };
    }

    hasPermission(permission) {
        if (this.state.currentUser && this.state.policies) {
            if (this.state.currentUser.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return this.state.policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            AccountStore.GetCurrentLoggedInUser().then((user) => {
                this.setState({ currentUser: user });
            });
            PermissionStore.GetMyPermissions().then((response) => {
                this.setState({ policies: response.data });
            });
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    showTab = (tab) => {
        this.setState((prevState) => {
            Object.keys(prevState.tabs).forEach(function (key) {
                prevState.tabs[key] = key == tab;
            });
            return { tabs: prevState.tabs };
        });
    };

    render() {
        return (
            <div>
                {/* Header Section */}
                <div className="flex items-center gap-3 pb-4 border-b border-gray-200">
                    <FontAwesomeIcon icon={["fad", "diagram-project"]} className="text-3xl text-purple-500" />
                    <div>
                        <h2 className="text-2xl font-semibold text-gray-800">Integrations</h2>
                        <p className="text-sm text-gray-600">Manage and run third-party integrations</p>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div className="md:col-span-1">
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                            {this.hasPermission("importUsersFromScadsys") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.scadsysImport ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("scadsysImport")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    Import Users from Scadsys
                                </a>
                            )}
                            {this.hasPermission("importUsersFromScadsys") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.scadsysPhotoImport ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("scadsysPhotoImport")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "image"]}></FontAwesomeIcon>
                                    Import Photos from Scadsys
                                </a>
                            )}
                            {this.hasPermission("importUsersFromScadsys") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.scadsysVisitorImport ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("scadsysVisitorImport")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "id-badge"]}></FontAwesomeIcon>
                                    Import Visitors from Scadsys
                                </a>
                            )}
                            {this.hasPermission("importGroupsFromScadsys") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.scadsysGroupImport ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("scadsysGroupImport")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "users"]}></FontAwesomeIcon>
                                    Import Groups from Scadsys
                                </a>
                            )}
                            {this.hasPermission("exportUsersToScadsys") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.scadsysUpdate ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("scadsysUpdate")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    Export to Scadsys
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.adamStudents ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("adamStudents")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    Import Students from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.adamStaff ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("adamStaff")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    Import Staff from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.adamClasses ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("adamClasses")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "users"]}></FontAwesomeIcon>
                                    Import Classes from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.edadmin ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("edadmin")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    Import from EdAdmin
                                </a>
                            )}
                            {this.hasPermission("exportUsersToEntegy") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.entegy ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("entegy")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "mobile"]}></FontAwesomeIcon>
                                    Export to Entegy
                                </a>
                            )}
                            {this.hasPermission("exportPhotosToAzure") && (
                                <a
                                    href="#"
                                    className={`block px-4 py-3 hover:bg-gray-50 transition-colors ${
                                        this.state.tabs.azurePhoto ? "bg-blue-50 border-l-4 border-l-blue-600 text-blue-700" : "text-gray-700"
                                    }`}
                                    onClick={() => this.showTab("azurePhoto")}
                                >
                                    <FontAwesomeIcon className="mr-2" icon={["fad", "image"]}></FontAwesomeIcon>
                                    Export Photo to Azure
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                            {this.hasPermission("importUsersFromScadsys") && this.state.tabs.scadsysImport && <ImportScadsysUsers organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromScadsys") && this.state.tabs.scadsysPhotoImport && <ImportScadsysPhotos organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromScadsys") && this.state.tabs.scadsysVisitorImport && <ImportScadsysVisitors organization={this.props.organization} />}
                            {this.hasPermission("importGroupsFromScadsys") && this.state.tabs.scadsysGroupImport && <ImportScadsysGroups organization={this.props.organization} />}
                            {this.hasPermission("exportUsersToScadsys") && this.state.tabs.scadsysUpdate && <ExportUsersToScadsys organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamStudents && <ImportADAMStudents organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamStaff && <ImportADAMStaff organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamClasses && <ImportADAMClasses organization={this.props.organization} />}
                            {this.hasPermission("importUsersFromADAM") && this.state.tabs.edadmin && <ImportEdAdminUsers organization={this.props.organization} />}
                            {this.hasPermission("exportUsersToEntegy") && this.state.tabs.entegy && <ExportEntegyUsers organization={this.props.organization} />}
                            {this.hasPermission("exportPhotosToAzure") && this.state.tabs.azurePhoto && <ExportAzurePhotos organization={this.props.organization} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
